import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Chiesa from "../components/Chiesa";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: "#fff",
  fontFamily: '"Penna"',
  fontSize: "1.8rem",
  fontWeight: "bold",
}));

function Cerimonia() {
  return (
    <Container maxWidth="xl" sx={{ pt: "1em" }}>
      <Box sx={{ width: "100%" }}>
        <Stack spacing={0}>
          <Item sx={{backgroundColor: "transparent"}}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            alignItems="stretch"
            justifyContent="center"
            sx={{
              display: { xs: "block", md: "none" },
            }}
          >
            <Grid item xs={12} style={{paddingTop: 10}}>
              <Typography
                variant="body1"
                color="text.primary"
                sx={{ paddingTop: "10px", paddingBottom: "10px", 

                  fontFamily: '"Penna"',
                  fontSize: "1.8rem",
                  color: "#fff",
                  fontWeight: "bold"
                }}
              >
                Non vogliamo per nulla al mondo che ti perda il giorno delle
                nozze! Qui puoi consultare l'indirizzo del luogo della
                cerimonia; ora non hai piu' scuse per arrivare tardi... a meno
                che tu non sia la sposa!
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Chiesa />
            </Grid>
            <Grid item xs={12}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2878.514770184443!2d7.835818577371853!3d43.82442334133792!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12d20b2d99a8a507%3A0x3b9d4e30a0620476!2sPiazza%20Don%20Francesco%20Lombardi%2C%2018038%20Bussana%20IM%2C%20Italy!5e0!3m2!1sen!2sat!4v1768575544887!5m2!1sen!2sat"
                style={{
                  border: 0,
                  width: "100%",
                  minHeight: "500px",
                  height: "640px",
                }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="map"
              ></iframe>
            </Grid>
          </Grid>
          {/* web */}
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            alignItems="stretch"
            justifyContent="center"
            sx={{
              display: { xs: "none", md: "flex" },
            }}
          >
            <Grid item xs={0} sm={6}>
              <Chiesa />
            </Grid>
            <Grid item xs={0} sm={6}>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ paddingTop: "10px", paddingBottom: "10px", 

                  fontFamily: '"Penna"',
                  fontSize: "1.8rem",
                  color: "#fff",
                  fontWeight: "bold"
                }}
              >
                Non vogliamo per nulla al mondo che ti perda il giorno delle
                nozze! Qui puoi consultare l'indirizzo del luogo della
                cerimonia; ora non hai piu' scuse per arrivare tardi... a meno
                che tu non sia la sposa!
              </Typography>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2878.514770184443!2d7.835818577371853!3d43.82442334133792!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12d20b2d99a8a507%3A0x3b9d4e30a0620476!2sPiazza%20Don%20Francesco%20Lombardi%2C%2018038%20Bussana%20IM%2C%20Italy!5e0!3m2!1sen!2sat!4v1768575544887!5m2!1sen!2sat"
                style={{
                  border: 0,
                  width: "100%",
                  minHeight: "500px",
                  height: "640px",
                }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="map"
              ></iframe>
            </Grid>
          </Grid>
        </Item>
      </Stack>
    </Box>
    </Container>
  );
}

export default Cerimonia;
